define([
	"csi/def/ActionFactory",
	"csi/heading/AttributeAction",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(ActionFactory,AttributeAction,MessageDialog,xml) {

	return ActionFactory.declare("RefDelete", AttributeAction, {
		constructor: function(obj) {
			this.m_id = "RefDelete";
			this.classController = "csi.heading.RefDeleteController";
			this.confirmAction = MessageDialog.BUTTON_YES;
			this.setBaseRights(xml.RIGHT_WRITE);
		},

		hasAccess: function(/*csi.def.Context*/ctx) {
			// summary: check to make sure the node exists before it can be reset
			return xml.isValidURL(this._getValue(ctx)) && this.inherited(arguments);
		}
	});
});